module.exports = __webpack_public_path__ + "static/media/midsummer.e27ac9c2.png";